module.exports = __webpack_public_path__ + "static/media/cv.85c9d587.svg";